import { motion } from 'framer-motion';
import { Star, ArrowRight } from 'lucide-react';

export const FinalCTASection = () => (
  <section className="py-24 md:py-32 bg-foreground border-t border-border overflow-hidden relative">
    {/* Giant typographic background number */}
    <div
      className="absolute right-0 top-0 select-none pointer-events-none leading-none"
      style={{
        fontSize: 'clamp(200px, 30vw, 380px)',
        fontWeight: 900,
        color: 'rgba(255,255,255,0.03)',
        lineHeight: 1,
        right: '-2%',
        top: '-10%',
        letterSpacing: '-0.05em',
      }}
    >
      8x
    </div>

    <div className="section-container relative z-10">
      <div className="max-w-3xl">
        <motion.p
          className="section-label mb-6"
          style={{ color: 'rgba(255,255,255,0.4)' }}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          Ready to Scale?
        </motion.p>

        <motion.h2
          className="text-[52px] sm:text-[64px] lg:text-[72px] font-extrabold tracking-tighter leading-none mb-7"
          style={{ color: '#ffffff' }}
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
        >
          Ready to 10x<br />Your Agency?
        </motion.h2>

        <motion.p
          className="text-[18px] leading-[1.55] mb-10 max-w-xl"
          style={{ color: 'rgba(255,255,255,0.65)' }}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          Get matched with pre-vetted Human+AI talent today. Tell us what you need, and you'll start delivering more—in 48 hours.
        </motion.p>

        <motion.div
          className="flex flex-col sm:flex-row gap-3 mb-10"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <a href="https://vibe.hirex8.com/register?type=client" className="btn-primary">
            Build Your Team Now
          </a>
          <a
            href="https://cal.com/matching-expert/30min"
            className="inline-flex items-center justify-center gap-2 px-7 py-[14px] rounded-full border-[1.5px] text-[17px] font-medium"
            style={{
              borderColor: 'rgba(255,255,255,0.3)',
              color: '#ffffff',
              textDecoration: 'none',
              transition: 'border-color 0.18s ease',
            }}
            onMouseEnter={e => e.currentTarget.style.borderColor = 'rgba(255,255,255,0.6)'}
            onMouseLeave={e => e.currentTarget.style.borderColor = 'rgba(255,255,255,0.3)'}
          >
            Book a Free Call <ArrowRight size={16} />
          </a>
        </motion.div>

        {/* Trust */}
        <motion.div
          className="flex flex-wrap items-center gap-5"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4, duration: 0.5 }}
        >
          <div className="flex items-center gap-2">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={13} style={{ fill: '#fbbf24', color: '#fbbf24' }} />
              ))}
            </div>
            <span className="text-[14px] font-medium" style={{ color: 'rgba(255,255,255,0.6)' }}>
              42 five-star reviews
            </span>
          </div>
          <span style={{ color: 'rgba(255,255,255,0.2)' }}>·</span>
          <span className="text-[14px] font-medium" style={{ color: 'rgba(255,255,255,0.6)' }}>Zero platform fees</span>
          <span style={{ color: 'rgba(255,255,255,0.2)' }}>·</span>
          <span className="text-[14px] font-medium" style={{ color: 'rgba(255,255,255,0.6)' }}>No commitment required</span>
        </motion.div>
      </div>
    </div>
  </section>
);
